
jQuery(document).ready(function($){

    //css support
    $('ul.col-2 li:nth-child(2n+2),ul.col-3 li:nth-child(3n+3),ul.col-4 li:nth-child(4n+4),ul.col-5 li:nth-child(5n+5),ul.col-6 li:nth-child(6n+6),ul.col-7 li:nth-child(7n+7)').css('margin-right','0');
    // your code
});


$(function(){
    var img_h=$("ul.product_con_list li .img").width();
    $("ul.product_con_list li .img").css("height",img_h/1.5);
});

// 动画
$(function(){
    // var wow = new WOW({
    //     boxClass: 'wow',
    //     animateClass: 'animated',
    //     offset: 0,
    //     mobile: true,
    //     live: true
    // });
    // wow.init();
});
// 数字增加
$(function(){
    // this.jQuery('.counter').countUp({
    //     delay: 10,
    //     time: 800
    // });
});
$(function(){
    // var nav=$(".cd-main-header"); //得到导航对象
    // var win=$(window); //得到窗口对象
    // var sc=$(document);//得到document文档对象。
    // win.scroll(function(){
    //     if(sc.scrollTop()>=60){
    //         nav.addClass("active");
    //         // $(".navTmp").fadeIn();
    //     }else{
    //         nav.removeClass("active");
    //         // $(".navTmp").fadeOut();
    //     }
    // })
})





//////////////////
// WEBPACK FOOTER
// ./static/js/public.js
// module id = nwBL
// module chunks = 41